"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_button_1 = require("../button/awsui-button");
var awsui_form_field_1 = require("../form-field/awsui-form-field");
var AttributeEditorRowWrapper = /** @class */ (function (_super) {
    __extends(AttributeEditorRowWrapper, _super);
    function AttributeEditorRowWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all fields. Fields are supplied in the `definition` property of the component.
     */
    AttributeEditorRowWrapper.prototype.findFields = function () {
        return this.findAll('.awsui-attribute-editor__field').map(function (f) { return new awsui_form_field_1.default(f.getElement()); });
    };
    AttributeEditorRowWrapper.prototype.findRemoveButton = function () {
        var outerFormField = new awsui_form_field_1.default(this.find('awsui-form-field').getElement());
        var button = outerFormField.findSecondaryControl();
        if (button) {
            return new awsui_button_1.default(button.find('awsui-button').getElement());
        }
        return null;
    };
    return AttributeEditorRowWrapper;
}(dom_1.ElementWrapper));
exports.AttributeEditorRowWrapper = AttributeEditorRowWrapper;
var AttributeEditorWrapper = /** @class */ (function (_super) {
    __extends(AttributeEditorWrapper, _super);
    function AttributeEditorWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttributeEditorWrapper.prototype.findEmptyRegion = function () {
        return this.find('[awsui-attribute-editor-region="empty"]');
    };
    /**
     * Returns a row for a given index.
     *
     * @param row 1-based row index
     */
    AttributeEditorWrapper.prototype.findRow = function (row) {
        var rowIndex = row * 2 - 1;
        var rowElement = this.find(".awsui-attribute-editor__row:nth-child(" + rowIndex + ")").getElement();
        return new AttributeEditorRowWrapper(rowElement);
    };
    /**
     * Returns all rows.
     *
     * To find a specific row use the `findRow(n)` function as chaining `findRows().get(n)` can return unexpected results.
     * @see findRow
     */
    AttributeEditorWrapper.prototype.findRows = function () {
        return this.findAll('.awsui-attribute-editor__row').map(function (i) { return new AttributeEditorRowWrapper(i.getElement()); });
    };
    AttributeEditorWrapper.prototype.findAddButton = function () {
        return new awsui_button_1.default(this.find('.awsui-attribute-editor__add-row awsui-button').getElement());
    };
    AttributeEditorWrapper.prototype.findAdditionalInfo = function () {
        return this.find('[awsui-attribute-editor-region="additionalInfo"]');
    };
    return AttributeEditorWrapper;
}(dom_1.ComponentWrapper));
exports.default = AttributeEditorWrapper;
//# sourceMappingURL=awsui-attribute-editor.js.map